import {
  FSA_COUNTRY_CODE,
  QUALIFICATION_CODE,
} from '../../constants/qualification.constants';

const ZIPCODE_TEMPLATE_DIRECTORY = '/templates/zipcodesTemplates';
const FSA_TEMPLATE_PATH = '/templates/fsaCodeTemplate.csv';

const isFsaTemplate = (
  countryCode: string,
  qualificationCode: number,
): boolean =>
  countryCode === FSA_COUNTRY_CODE &&
  qualificationCode === QUALIFICATION_CODE.FSA;

export const locationTemplateFileName = (
  countryCode: string,
  qualificationCode: number,
): string =>
  isFsaTemplate(countryCode, qualificationCode)
    ? 'fsaCodeTemplate.csv'
    : `zipcode_template_${countryCode}.csv`;

export const locationTemplatePath = (
  countryCode: string,
  qualificationCode: number,
): string =>
  isFsaTemplate(countryCode, qualificationCode)
    ? FSA_TEMPLATE_PATH
    : `${ZIPCODE_TEMPLATE_DIRECTORY}/${locationTemplateFileName(countryCode, qualificationCode)}`;
